import React, {useContext} from "react";
import {Fade} from "react-reveal";
import "./Project.scss";
import {AcademicAndProfessionalProjects} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

export default function Projects() {
  const {isDark} = useContext(StyleContext);
  if (!AcademicAndProfessionalProjects.display) return null;

  return (
    <section className={`projects ${isDark ? "dark" : ""}`} id="projects">
      <Fade bottom duration={700} distance="20px">
        <div className="projects__inner">
          <div className="projects__header">
            <span className="section-label">Work</span>
            <h2 className="projects__title">
              {AcademicAndProfessionalProjects.title}
            </h2>
          </div>

          {/* Update projects here — edit AcademicAndProfessionalProjects in portfolio.js */}
          <div className="case-list">
            {AcademicAndProfessionalProjects.projects.map((p, i) => (
              <Fade
                key={i}
                bottom
                duration={600}
                distance="16px"
                delay={i * 80}
              >
                <article className="case">
                  {/* Header row */}
                  <div className="case__head">
                    <div className="case__num">
                      {String(i + 1).padStart(2, "0")}
                    </div>
                    <h3 className="case__name">{p.projectName}</h3>
                    {p.githubLink && (
                      <a
                        href={p.githubLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="case__gh"
                        aria-label={p.linkLabel || "GitHub repository"}
                      >
                        {p.linkLabel || "GitHub"} ↗
                      </a>
                    )}
                  </div>

                  {/* Text-only body */}
                  <div className="case__body">
                    <div className="case__fields">
                      <div className="case__field">
                        <span className="field-key">Problem</span>
                        <p className="field-val">{p.problem}</p>
                      </div>

                      <div className="case__field">
                        <span className="field-key">Approach</span>
                        <ul className="field-list">
                          {p.approach.map((a, j) => (
                            <li key={j}>{a}</li>
                          ))}
                        </ul>
                      </div>

                      <div className="case__field">
                        <span className="field-key">System</span>
                        <ul className="field-list">
                          {p.system.map((s, j) => (
                            <li key={j}>{s}</li>
                          ))}
                        </ul>
                      </div>

                      <div className="case__field">
                        <span className="field-key">Results</span>
                        <ul className="field-list field-list--results">
                          {p.results.map((r, j) => (
                            <li key={j}>{r}</li>
                          ))}
                        </ul>
                      </div>

                      <div className="case__field case__field--tech">
                        <span className="field-key">Stack</span>
                        <div className="field-tags">
                          {p.tech.map((t, j) => (
                            <span key={j} className="tech-tag">
                              {t}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              </Fade>
            ))}
          </div>
        </div>
      </Fade>
    </section>
  );
}
